<template>
  <div>
      <div class="circle" @click="OpenProducten" v-show="this.search == ''">
        {{ cat.name }}
      </div>

      <div v-show="productenShow" class="producten">
        <product
          v-for="product in cat.producten"
          :product="product"
          :key="product.id"
          :cart = "cart"
          :search="search"
          @changed="ChangedAantal"
        ></product>
      </div>
  </div>
</template>

<script>
import Product from './Product.vue'

export default {
  name: 'Categorie',

  props: ['cat', 'search', 'cart'],

  data() {
    return {
      productenShow: false
    }
  },

  components: {
    Product
  },

  methods: {
    ChangedAantal(val) {
      this.$emit('changed', val);
    },

    OpenProducten() {
      if(this.productenShow)
        this.productenShow = false;
      else 
        this.productenShow = true;
    }
  },

  watch: {
    search: function () {
      if(this.search != '')
        this.productenShow = true;
      else 
        this.productenShow = false;
    }
  }

}
</script>

<style>
  .producten {
    float:left;
    width:100%;
    margin-top:20px;
  }

  .circle {
    transition: 0.5s all;
    cursor: pointer;
    height: 50px;
    float: left;
    /* border-radius: 25px; */
    font-size: 20px;
    margin: 10px;
    width: calc(50% - 20px);
    color: #fff;
    line-height: 47px;
    text-align: center;
    -webkit-box-shadow: 10px 10px 5px -8px rgba(0,0,0,0.75);
    box-shadow: 10px 10px 5px -8px rgba(0,0,0,0.75);
    background: #2ab6d6;
    cursor:pointer;
  }
</style>
